<template>
  <div class="content__column content__column--small">
    <h1 class="content__title">Información del cupón</h1>
    <div class="information" v-if="cupon">
      <p v-if="cupon.code" class="information__text">
        <strong class="information__text--strong">Código: </strong
        >{{ cupon.code }}
      </p>

      <p v-if="cupon.type_name" class="information__text">
        <strong class="information__text--strong">Tipo: </strong
        ><span v-text="cupon.type_name"></span>
      </p>

      <p v-if="cupon.amount_mxn" class="information__text">
        <strong class="information__text--strong">Monto en pesos: </strong
        ><span>{{ cupon.amount_mxn | price }}</span>
      </p>

      <p v-if="cupon.amount_usd" class="information__text">
        <strong class="information__text--strong">Monto en dólares: </strong
        ><span>{{
          cupon.amount_usd | price({ currency: "USD", lang: "en-US" })
        }}</span>
      </p>

      <p v-if="cupon.usage_name" class="information__text">
        <strong class="information__text--strong">Uso: </strong
        ><span v-text="cupon.usage_name"></span>
      </p>
			
			<p class="information__text">
        <strong class="information__text--strong">Mostrado en popup: </strong
        ><span>{{popup }}</span>
      </p>
      
			<p v-if="cupon.expiration_date" class="information__text">
        <strong class="information__text--strong">Fecha de Expiración: </strong
        >{{ cupon.expiration_date | longDate }}
      </p>

      <p v-if="cupon.status_name" class="information__text">
        <strong class="information__text--strong">Estatus: </strong
        >{{ cupon.status_name }}
      </p>

      <p v-if="cupon.text1_es" class="information__text">
        <strong class="information__text--strong">Texto 1 Español: </strong
        >{{ cupon.text1_es }}
      </p>

      <p v-if="cupon.text2_es" class="information__text">
        <strong class="information__text--strong">Texto 2 Español: </strong
        >{{ cupon.text2_es }}
      </p>

      <p v-if="cupon.text1_en" class="information__text">
        <strong class="information__text--strong">Texto 1 Inglés: </strong
        >{{ cupon.text1_en }}
      </p>

      <p v-if="cupon.text2_en" class="information__text">
        <strong class="information__text--strong">Texto 2 Inglés: </strong
        >{{ cupon.text2_en }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    cupon: {
      type: Object
    }
  },
	computed: {
		popup: function () {
			return this.cupon.popup ? 'Sí' : 'No'
		}
	}
};
</script>



// WEBPACK FOOTER //
// src/components/discount_cupons/view.vue